module.exports = "/images/profilemenu.svg";